import { buildApiUrl } from "../../../services/apiConfig";

export const loginUser = async (username, password) => {
  try {
    sessionStorage.removeItem('chatbot_messages');
    sessionStorage.removeItem('chatbot_hasStarted');

    const response = await fetch(buildApiUrl('AUTH', '/auth/login'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Login failed');
    }
    
    sessionStorage.setItem('token', data.token);
    sessionStorage.setItem('user_id', data.user_id);
    sessionStorage.setItem('username', data.username);
    sessionStorage.setItem('role', data.role);
    
    try {
      await deleteCollectionName(data.user_id);
    } catch (error) {
      console.error("Error deleting collection:", error);
    }
    
    return data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const isAuthenticated = () => {
  return sessionStorage.getItem('token') !== null;
};

export const getUserRole = () => {
  return sessionStorage.getItem('role');
};

export const getUserID = () => {
  return sessionStorage.getItem('user_id');
};

export const hasRole = (requiredRole) => {
  const userRole = getUserRole();
  return userRole === requiredRole;
};

export const hasAnyRole = (requiredRoles) => {
  const userRole = getUserRole();
  return requiredRoles.includes(userRole);
};

export const isAdmin = () => {
  return getUserRole()?.toLowerCase() === 'admin';
};

export const isAdvisor = () => {
  return getUserRole()?.toLowerCase() === 'advisor';
};

export const isInvestmentBanker = () => {
  return getUserRole()?.toLowerCase() === 'investment banker';
};

export const logout = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('user_id');
  sessionStorage.removeItem('username');
  sessionStorage.removeItem('role'); 
  sessionStorage.removeItem('chatbot_messages');
  sessionStorage.removeItem('chatbot_hasStarted');
};

export const signupUser = async (username, password, name) => {
  try {
    const response = await fetch(buildApiUrl('AUTH', '/auth/signup'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password, name }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Signup failed');
    }
    
    sessionStorage.setItem('token', data.token);
    sessionStorage.setItem('user_id', data.user_id);
    sessionStorage.setItem('username', data.username);
    sessionStorage.setItem('role', data.role); 

    return data;
  } catch (error) {
    console.error('Signup error:', error);
    throw error;
  }
};

const deleteCollectionName = async (userId) => {
  try {
    const response = await fetch(buildApiUrl('UPLOAD', `/collections/U${userId}`), {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Collection deletion failed');
    }
    
    return data;
  } catch (error) {
    console.error('Collection deletion error:', error);
    throw error;
  }
};